import comp from "./DialogueBox";
export default comp;
